import React, { useRef } from 'react';
import { TextField, InputAdornment, IconButton } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

const DateInput = ({ item, index, signed = false, onChange }) => {
  const inputRef = useRef(null);

  const isFirefox = typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent);

  const handleChange = (e) => {
    const value = e.target.value;
    if (onChange) {
      onChange(value);
    } else {
      item.answer = value;
    }
  };

  const openPicker = () => {
    if (!inputRef.current || signed) return;
    const input = inputRef.current;
    if (typeof input.showPicker === 'function') {
      input.showPicker();
      input.focus();
    } else {
      input.click();
    }
  };

  return (
    <div
      style={{
        maxWidth: '300px',
        marginTop: '10px'
      }}>
      <TextField
        size="small"
        type="date"
        variant="outlined"
        fullWidth
        disabled={signed}
        value={item.answer || ''}
        onChange={handleChange}
        inputRef={inputRef}
        InputLabelProps={{
          shrink: true
        }}
        InputProps={
          isFirefox
            ? {}
            : {
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={openPicker} size="small" disabled={signed} tabIndex={-1}>
                      <CalendarMonthIcon style={{ color: 'black' }} />
                    </IconButton>
                  </InputAdornment>
                )
              }
        }
        sx={{
          '& input::-webkit-calendar-picker-indicator': {
            opacity: 0,
            display: 'none'
          }
        }}
        inputProps={{
          autoComplete: 'off'
        }}
      />
    </div>
  );
};

export default DateInput;
